import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import { IFiltersArea } from './interfaces'

export const StyledFiltersArea = styled(Grid)<IFiltersArea>`
  flex-grow: 1;
  flex-basis: ${({ hasFilter }) => (hasFilter ? '160px' : '0')};
  min-width: 0; /* Trick to prevent it from overflowing */
`
